import { c as _c } from "react/compiler-runtime";
import { Box, VStack } from '@chakra-ui/react';
import { MembersToolbar } from '@src/components/sco/Members/MembersLayout/MembersToolbar';
import React, { ReactNode } from 'react';
type MembersMainPanelProps = {
  children?: ReactNode;
};
export const MembersMainPanel = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <MembersToolbar />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.children) {
    t1 = <VStack flexGrow={1} gap={0} height="full" maxHeight="100%" minHeight={0} overflow="hidden">{t0}<Box flex={1} minHeight={0} overflowY="auto" width="full">{props.children}</Box></VStack>;
    $[1] = props.children;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};